export let QboIntegrationLineItemType = /*#__PURE__*/function (QboIntegrationLineItemType) {
  QboIntegrationLineItemType["QBO"] = "qbo";
  return QboIntegrationLineItemType;
}({});